require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./article-173-schedule-confirmation-available-in-the-construction-edition.json") })
        }
      }, "path---article-173-schedule-confirmation-available-in-the-construction-edition");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---article-173-schedule-confirmation-available-in-the-construction-edition!./.cache/json/article-173-schedule-confirmation-available-in-the-construction-edition.json
// module id = 522
// module chunks = 231608221292675